import { useEffect } from 'react'
import { useQuery, gql, NetworkStatus } from '@apollo/client'
import { FormattedMessage } from 'react-intl'
import { NavLink } from 'react-router-dom'
import { isEmpty } from 'lodash'

import EmptyState from 'components/v2/EmptyState'
import { Loader } from '@10xLabs/react-web/components/Loader'
import { Button } from 'components/v2/Button'
import { filterEmptyValue } from 'utils/object'

const LIMIT = 30

const GET_INBOUND_ORDERS = gql`
  query GetInboundOrders(
    $limit: Int!
    $page: Int!
    $destinationId: ID
    $id: ID
    $conciliationStatus: OrderConciliationStatus
    $itemId: ID
  ) {
    orders(
      pagination: { size: $limit, page: $page }
      input: { destinationID: $destinationId, id: $id, conciliationStatus: $conciliationStatus, itemID: $itemId }
    ) {
      total
      items {
        id
        status
        conciliationStatus
        createdAt
        type
        origin {
          id
          name
        }
        supplier
        createdBy {
          id
          username
          firstName
          lastName
        }
        lineItems {
          itemID
          name
          container
          netContent
          units
          ordered
          received
        }
      }
    }
  }
`

export const withInboundOrders =
  (List: TSFixMe, Pagination: TSFixMe): TSFixMe =>
  (props: TSFixMe): TSFixMe => {
    const {
      loading,
      error,
      data = {},
      refetch,
      networkStatus
    } = useQuery(GET_INBOUND_ORDERS, {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
      notifyOnNetworkStatusChange: true,
      variables: {
        limit: props.limit || LIMIT,
        page: props.page - 1,
        destinationId: props.inventoryId,
        ...filterEmptyValue({
          id: props.filters.id,
          conciliationStatus: props.filters.conciliationStatus,
          itemId: props.filters.itemId
        })
      }
    })

    useEffect((): TSFixMe => {
      refetch()
    }, [])

    if (networkStatus === NetworkStatus.refetch || loading) {
      return (
        <EmptyState.Container>
          <Loader />
        </EmptyState.Container>
      )
    } else if (error) {
      return (
        <EmptyState.Container>
          <EmptyState.Description>
            <FormattedMessage
              id="spanish.inboundOrders.error.description"
              defaultMessage="Hubo un error al cargar tus entradas"
            />
          </EmptyState.Description>

          <EmptyState.Action>
            <Button onClick={(): TSFixMe => refetch()} kind="primary">
              <FormattedMessage id="spanish.inboundOrders.error.action" defaultMessage="Recargar sus entradas" />
            </Button>
          </EmptyState.Action>
        </EmptyState.Container>
      )
    } else if (isEmpty(data.orders.items) && props.page === 1 && isEmpty(filterEmptyValue(props.filters))) {
      return (
        <EmptyState.Container>
          <EmptyState.Description>
            <FormattedMessage
              id="spanish.inboundOrders.empty.description"
              defaultMessage="No tienes ninguna entrada por el momento"
            />
          </EmptyState.Description>
        </EmptyState.Container>
      )
    } else if (isEmpty(data.orders.items)) {
      return (
        <EmptyState.Container>
          <EmptyState.Description>
            <FormattedMessage
              id="spanish.inboundOrders.empty.filters.description"
              defaultMessage="No se encontró información"
            />
          </EmptyState.Description>

          <EmptyState.Action>
            <Button as={NavLink} to={props.urls.inboundOrders} kind="primary">
              <FormattedMessage id="spanish.inboundOrders.empty.filters.action" defaultMessage="Borrar filtros" />
            </Button>
          </EmptyState.Action>
        </EmptyState.Container>
      )
    } else {
      return (
        <>
          <List orders={data.orders.items} {...props} />

          <Pagination
            totalItems={data.orders.total}
            currentItemsCount={data.orders.items.length}
            {...props}
            limit={props.limit || LIMIT}
          />
        </>
      )
    }
  }
